import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import rCoin from "../assets/images/rcoin.png";
import useTranslation from "../hooks/useTranslation";

// Parsed as local midnight: `new Date("2026-10-01")` shifts a day back for
// viewers west of Greenwich.
const parseDay = (value) => {
  const [y, m, d] = String(value || "").split("-").map(Number);
  return y && m && d ? new Date(y, m - 1, d) : null;
};

const HostSettlement = () => {
  const { hostHistory } = useSelector((state) => state.history);
  const languageCode = useSelector((state) => state.language?.selectedLanguageCode);
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  // Latin digits in every language, so the ledger stays comparable across locales.
  const locale = `${languageCode || "en"}-u-nu-latn`;
  const coins = (n) => Number(n || 0).toLocaleString(locale);
  const money = (n) =>
    Number(n || 0).toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  // Vendor stores payout dates as locale-blind strings, so an unparseable value
  // must fall through to "n/a" instead of throwing inside Intl.
  const fmt = (d, opts) =>
    d instanceof Date && !Number.isNaN(d.getTime())
      ? new Intl.DateTimeFormat(locale, opts).format(d)
      : "";

  useEffect(() => {
    setData(hostHistory);
  }, [hostHistory]);

  return (
    <div style={{ padding: "16px", maxWidth: "600px", margin: "0 auto" }}>
      {data?.length > 0 ? (
        data.map((row) => (
          <div
            key={row?.startDate}
            style={{
              background: "var(--mx-surface)",
              border: "1px solid var(--mx-border)",
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "12px",
            }}
          >
            {/* Period Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
                paddingBottom: "8px",
                borderBottom: "1px solid var(--mx-border)",
              }}
            >
              <span style={{ color: "var(--mx-text-2)", fontSize: "14px" }}>
                {t("period")}
              </span>
              <span
                style={{
                  color: "var(--mx-accent)",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {fmt(parseDay(row?.startDate), {
                  month: "short",
                  day: "numeric",
                })}{" "}
                –{" "}
                {fmt(parseDay(row?.endDate), {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </span>
            </div>

            {/* Total Coin Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
                paddingBottom: "8px",
                borderBottom: "1px solid var(--mx-border)",
              }}
            >
              <span style={{ color: "var(--mx-text-2)", fontSize: "14px" }}>
                {t("total_coin")}
              </span>
              <span
                style={{
                  color: "var(--mx-text)",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {coins(row?.amount)}
              </span>
            </div>

            {/* Payment Date Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span style={{ color: "var(--mx-text-2)", fontSize: "14px" }}>
                {t("payment_date")}
              </span>
              <span
                style={{
                  color: "var(--mx-text)",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {row?.statusOfTransaction === 1
                  ? t("pending")
                  : fmt(row?.payoutDate && new Date(row.payoutDate), {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    }) || t("na")}
              </span>
            </div>

            {/* Amount Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ color: "var(--mx-text-2)", fontSize: "14px" }}>
                {t("amount")}
              </span>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img src={rCoin} alt="R Coin" height={20} width={20} />
                <span
                  style={{
                    color: "var(--mx-accent)",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  {money(row?.dollar)}
                </span>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "var(--mx-text-2)",
            fontSize: "16px",
            background: "transparent",
            borderRadius: "12px",
            // border: "1px solid var(--mx-border)"
          }}
        >
          {t("no_data_found")}
        </div>
      )}
    </div>
  );
};

export default HostSettlement;
